import { withPreRenderSettings } from '@/utils/hocs';
import { HelpView } from '@/views/Help/Help.view';

function HelpPage() {
  return <HelpView />;
}

HelpPage.getInitialProps = withPreRenderSettings(() => {
  return { props: {} };
});

export default HelpPage;
